import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { LeaseProcessComponent } from './lease-process/lease-process.component';
import { MatIconModule } from '@angular/material/icon';
import { MatCardModule } from '@angular/material/card';
import { FaqComponent } from './faq/faq.component';
import { MatButtonModule } from '@angular/material/button';
import { TranslateModule } from '@ngx-translate/core';
import { IvyCarouselModule } from 'angular-responsive-carousel';
import { DirectivesModule } from '../directives/directives.module';
import { TourMatMenuModule } from 'ngx-ui-tour-md-menu';


@NgModule({
  declarations: [LeaseProcessComponent, FaqComponent],
  imports: [
    CommonModule,
    MatIconModule,
    MatCardModule,
    MatButtonModule,
    IvyCarouselModule,
    TranslateModule.forChild({
      extend: true,
    }),
    DirectivesModule,
    TourMatMenuModule
  ],
  exports: [
    LeaseProcessComponent,
    FaqComponent
  ],
})
export class ComponentsModule { }
